/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.media.getUploadStatus";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"uploadId":/*#__PURE__*/ l.string()});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"status":/*#__PURE__*/ l.string<{"knownValues":["pending","processing","done","error"]}>(),"progress":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({"minimum":0,"maximum":100})),"tracks":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<TrackRef>((() => trackRef) as any), )),"durationMs":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"error":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get the processing status of a previously created upload. Only accessible by the DID that created the upload. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["NotFound"]);

export { main };

export const $lxm = $nsid;

type TrackRef = { $type?: "place.stream.media.getUploadStatus#trackRef";"uri":l.AtUriString;"cid":string };

export type { TrackRef };

const trackRef = /*#__PURE__*/ l.typedObject<TrackRef>($nsid, "trackRef", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string()}));

export { trackRef };
